module.exports = __webpack_public_path__ + "static/media/app-werbung.fafd5120.png";